import { render, staticRenderFns } from "./NovaOcorrencia.vue?vue&type=template&id=c2013d74"
import script from "./NovaOcorrencia.vue?vue&type=script&lang=js"
export * from "./NovaOcorrencia.vue?vue&type=script&lang=js"
import style0 from "./NovaOcorrencia.vue?vue&type=style&index=0&id=c2013d74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports